import React from "react";
import { DetailCard } from "../../Helpers/Components/Needed";
import { FaAddressCard } from "react-icons/fa";
import { IoLocation } from "react-icons/io5";

const Aadhaar = (data) => {
    return (
        <React.Fragment>
            <DetailCard title="Aadhaar Details" icon={<FaAddressCard />}>
                <div className="aadhaar-hero mb-4 p-4">
                    <div className="row align-items-center">
                        {data?.rejected?.details?.aadhaar_xml_data?.profile_image && (
                            <div className="col-md-3 text-center mb-3 mb-md-0">
                                <img src={`data:image/jpeg;base64,${data?.rejected?.details?.aadhaar_xml_data?.profile_image}`} className="aadhaar-photo" alt="Aadhaar" />
                            </div>
                        )}
                        <div className="col-md-9" >
                            <div className="info-grid" >
                                <div className="info-field">
                                    <div className="info-field-label"> FULL NAME </div>
                                    <div className="info-field-value">{data?.rejected?.details?.aadhaar_xml_data?.full_name || "-"}</div>
                                </div>
                                <div className="info-field">
                                    <div className="info-field-label"> GENDER </div>
                                    <div className="info-field-value">{data?.rejected?.details?.aadhaar_xml_data?.gender === "M" ? "Male" : "Female" || "-"}</div>
                                </div>
                                <div className="info-field">
                                    <div className="info-field-label"> DATE OF BIRTH</div>
                                    <div className="info-field-value">{data?.rejected?.details?.aadhaar_xml_data?.dob || "-"}</div>
                                </div>
                                <div className="info-field">
                                    <div className="info-field-label"> MOBILE NUMBER </div>
                                    <div className="info-field-value">+91 {data?.rejected?.details?.digilocker_metadata?.mobile_number || "-"}</div>
                                </div>
                                <div className="info-field">
                                    <div className="info-field-label"> AADHAAR NUMBER </div>
                                    <div className="info-field-value">{data?.rejected?.details?.aadhaar_xml_data?.masked_aadhaar || "-"}</div>
                                </div>
                                <div className="info-field">
                                    <div className="info-field-label"> YEAR OF BIRTH </div>
                                    <div className="info-field-value">{data?.rejected?.details?.aadhaar_xml_data?.yob || "-"}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mb-4 px-3">
                    <h4 className="mb-3"> <IoLocation className="text-primary" /> Address Details</h4>
                    <div className="address-display mb-4" >
                        <h6>Full Address</h6>
                        {
                            data?.rejected?.details?.aadhaar_xml_data?.full_address ?
                                <p className="m-0">{data?.rejected?.details?.aadhaar_xml_data?.full_address}</p>
                                :
                                <p className="m-0 text-muted">No address details available</p>
                        }
                    </div>
                    <div className="info-grid px-3" >
                        <div className="info-field">
                            <div className="info-field-label"> House Number </div>
                            <div className="info-value">{data?.rejected?.details?.aadhaar_xml_data?.address?.house || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Street </div>
                            <div className="info-value">{data?.rejected?.details?.aadhaar_xml_data?.address?.street || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Landmark </div>
                            <div className="info-value">{data?.rejected?.details?.aadhaar_xml_data?.address?.landmark || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Locality </div>
                            <div className="info-value">{data?.rejected?.details?.aadhaar_xml_data?.address?.loc || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Village/Town/City </div>
                            <div className="info-value">{data?.rejected?.details?.aadhaar_xml_data?.address?.vtc || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label">Sub District </div>
                            <div className="info-value">{data?.rejected?.details?.aadhaar_xml_data?.address?.subdist || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> District </div>
                            <div className="info-value">{data?.rejected?.details?.aadhaar_xml_data?.address?.dist || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> State </div>
                            <div className="info-value">{data?.rejected?.details?.aadhaar_xml_data?.address?.state || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Pincode </div>
                            <div className="info-value">{data?.rejected?.details?.aadhaar_xml_data?.zip || "-"}</div>
                        </div>
                    </div>
                </div>
                {
                    data?.rejected?.photo?.length ?
                        <div className="my-3">
                            <div className="row">
                                {
                                    data?.rejected?.photo?.map((ele, i) => {
                                        return (
                                            <div className="col-md-6" key={ele}> 
                                          <div className="aadhaar-images">  <img src={ele} alt="Aadhaar" />  </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        : ""
                }
            </DetailCard>
        </React.Fragment>
    )
}

export default Aadhaar